 export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };


  export const subjects = [
    {
      name: "COMMERCE",
    },
    {
      name: "AGRICULTURAL SCIENCE"
    },
    {
      name: "BIOLOGY"
    },
    {
      name: "CHEMISTRY"
    },
    {
      name: "CHRISTIAN RELIGIOUS STUDIES"
    },
    {
      name: "CIVIC EDUCATION"
    },
    {
      name: "COMPUTER STUDIES"
    },
    {
      name: "DATA PROCESSING"
    },
    {
      name: "ECONOMICS"
    },
    {
      name: "ENGLISH LANGUAGE"
    },
    {
      name: "FINANCIAL ACCOUNTING"
    },
    {
      name: "FURTHER MATHEMATICS"
    },
    {
      name: "GEOGRAPHY"
    },
    {
      name: "GOVERNMENT"
    },
    
    {
      name: "HAUSA"
    },
    {
      name: "HISTORY"
    },
    {
      name: "HOME MANAGEMENT"
    },
    {
      name: "IGBO"
    },
    
    {
      name: "ISLAMIC RELIGIOUS STUDIES"
    },
    {
      name: "LITERATURE IN ENGLISH"
    },
    {
      name: "MARKETING"
    },
    {
      name: "MATHEMATICS"
    },
    {
      name: "PHYSICS"
    },
    {
      name: "YORUBA"
    },
    {
      name: "FOOD AND NUTRITION"
    },
    {
      name: "FRENCH"
    },
    {
      name: "TEACHING PRACTICE"
    },
    {
      name: "EDUCATION"
    },
    {
      name: "INTEGRATED SCIENCE"
    },
    {
      name: "PHYSICAL HEALTH EDUCATION (P.H.E)"
    },
    {
      name: "SOCIAL STUDIES"
    },
    {
      name: "FABRICATION & WELDING"
    },
    {
      name: "ENGINEERING DRAWING"
    },
    {
      name: "CARPENTRY"
    },
    {
      name: "ICT"
    },
    {
      name: "ANIMAL HUSBANDRY"
    },
    {
      name: "GENERAL METAL WORK"
    },
    {
      name: "GENERAL WOODWORK"
    },
    {
      name: "BASIC ELECTRICITY"
    },
    {
      name: "FISHERIES"
    },
    {
      name: "FOUNDRY"
    },
    {
      name: "REFRIGERATION & AIRCONDITIONING"
    },
    {
      name: "HEALTH EDUCATION"
    },
    {
      name: "BOOK KEEPING"
    },
    {
      name: "SALESMANSHIP"
    },
    
  ]

  export const grading = [
    {
      name:"A1"
    },
    {
      name:"B2"
    },
    {
      name:"B3"
    },
    {
      name:"C4"
    },
    {
      name:"C5"
    },
    {
      name:"C6"
    },
    {
      name:"D7"
    },
    {
      name:"E8"
    },
    {
      name:"F9"
    },
  ]